import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Check, FloppyDisk } from '@phosphor-icons/react';
import { API, ROLES, ALL_PERMISSIONS } from './adminConstants';

export function PermissionsPanel() {
  const { getAuthHeader } = useAuth();
  const [perms, setPerms] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/permissions`, { headers: getAuthHeader() }).then(r => setPerms(r.data)).catch(() => {});
  }, []);

  const toggle = (role, perm) => {
    setPerms(prev => {
      const current = prev[role] || [];
      const updated = current.includes(perm) ? current.filter(p => p !== perm) : [...current, perm];
      return { ...prev, [role]: updated };
    });
  };

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/permissions`, perms, { headers: getAuthHeader() });
      toast.success('Permissions saved');
    } catch { toast.error('Failed to save'); }
    setSaving(false);
  };

  return (
    <div data-testid="permissions-panel">
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="font-outfit font-bold text-2xl text-slate-900">Role Permissions</h1><p className="text-slate-500 text-sm">Configure which admin functions each role can access</p></div>
        <Button onClick={save} disabled={saving} className="bg-lime-600 hover:bg-lime-700" data-testid="save-permissions"><FloppyDisk size={15} className="mr-1" />{saving ? 'Saving...' : 'Save Permissions'}</Button>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto">
        <table className="w-full">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="text-left px-4 py-3 text-xs font-semibold text-slate-600">Permission</th>
              {ROLES.map(r => <th key={r.value} className="text-center px-3 py-3 text-xs font-semibold text-slate-600">{r.label}</th>)}
            </tr>
          </thead>
          <tbody>
            {ALL_PERMISSIONS.map(p => (
              <tr key={p.key} className="border-b border-slate-100">
                <td className="px-4 py-3 text-sm text-slate-700">{p.label}</td>
                {ROLES.map(r => (
                  <td key={r.value} className="text-center px-3 py-3">
                    <button onClick={() => r.value !== 'admin' && toggle(r.value, p.key)} className={`w-6 h-6 rounded-md border flex items-center justify-center transition-colors ${(perms[r.value] || []).includes(p.key) || r.value === 'admin' ? 'bg-lime-500 border-lime-500 text-white' : 'border-slate-300 hover:border-lime-300'}`} disabled={r.value === 'admin'} data-testid={`perm-${r.value}-${p.key}`}>
                      {((perms[r.value] || []).includes(p.key) || r.value === 'admin') && <Check size={14} weight="bold" />}
                    </button>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-400 mt-2">Admin role always has full access and cannot be modified.</p>
    </div>
  );
}
